module.exports = __webpack_public_path__ + "img/XIYFT.png";